/**
 * Registry of tab groups that have mounted, maintained by the tab layout
 * (registerMountedTab in its mount effect). This is the cold/warm ground
 * truth for cross-tab slide-menu selections: the tabs navigator's parent
 * state does not reliably expose child stacks, and freezeOnBlur suspends
 * blurred tabs — which runs their effect cleanups — so registration is
 * one-way (a frozen tab is warm, not cold).
 *
 * Community switches rebuild the whole (app) tree via resetAppNavigationTree
 * (AuthProvider), which makes every tab cold again — so the reset clears the
 * registry (resetMountedTabs). Without the clear, a revisited community's
 * long-unmounted tabs would read as warm and send cross-tab selections down
 * the warm navigate-then-replace path on a cold tab — the double-load task
 * 332 fixed.
 */
const mountedTabs = new Set<string>();

export function registerMountedTab(tabName: string | undefined) {
  if (tabName) {
    mountedTabs.add(tabName);
  }
}

export function isTabMounted(tabName: string) {
  return mountedTabs.has(tabName);
}

/** Called when the app tree is reset (community switch): every tab is cold again. */
export function resetMountedTabs() {
  mountedTabs.clear();
}
